module.exports = __webpack_public_path__ + "media/images/logo_note_2-d56c2f024b10cd875edae2abf57dabe9.png";